<template>
    <el-drawer
        title="添加学生"
        :visible.sync="show"
        :wrapperClosable="false"
        direction="rtl"
        size="600px"
        :before-close="close">
        <div class="panel fx-g1">
            <el-tabs v-model="activeTab" class="fx-g1 fx-col inner_tags-page">
                <el-tab-pane label="单个添加" name="addOne" >
                    <el-form ref="form" :model="form" label-width="150px" class="edit_form">
                        <el-form-item label="学生姓名">
                            <el-input v-model="form.name"></el-input>
                        </el-form-item>
                        <el-form-item label="学生密码">
                            <div class="fx-col">
                                <el-input v-model="form.password" show-password></el-input>
                                <span class="text_info tr">*不提供密码则使用默认密码123456</span>
                            </div>
                        </el-form-item>
                        <el-form-item label="手机号">
                            <el-input v-model="form.phone"></el-input>
                        </el-form-item>
                        <el-form-item label="家长姓名">
                            <el-input v-model="form.parentName"></el-input>
                        </el-form-item>
                        <el-form-item label="学校">
                            <el-input v-model="form.schoolName"></el-input>
                        </el-form-item>

                    </el-form>

                </el-tab-pane>
                <el-tab-pane label="批量添加" name="addByBatch">
                    <el-form ref="form2" :model="form2" label-width="150px" class="edit_form">
                        <div  v-if="!hasType">
                            <el-form-item label="姓名">
                                <el-input v-model="form2.names" type="textarea" placeholder="请输入学员姓名，一行一个姓名"
                                        rows="10"></el-input>
                            </el-form-item>
                            <el-form-item label="密码" >
                                <div class="fx-col">
                                    <el-input v-model="form2.password" show-password></el-input>
                                    <span class="text_info tr">*不提供密码则使用默认密码123456</span>
                                </div>
                            </el-form-item>
                        </div>
                        <div  v-if="hasType">
                            <el-form-item label="类型">
                                <el-select v-model="type">
                                    <el-option label="新生" value="1"></el-option>
                                    <el-option label="老生" value="2"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="姓名" v-if="type == 1">
                                <el-input v-model="form2.names" type="textarea" placeholder="请输入学员姓名，一行一个姓名"
                                        rows="10"></el-input>
                            </el-form-item>
                            <el-form-item label="姓名" v-if="type == 2">
                                <el-input v-model="form2.sns" type="textarea" placeholder="请输入学员账号，一行一个账号"
                                        rows="10"></el-input>
                            </el-form-item>
                            <el-form-item label="密码" v-if="type == 1">
                                <div class="fx-col">
                                    <el-input v-model="form2.password" show-password></el-input>
                                    <span class="text_info tr">*不提供密码则使用默认密码123456</span>
                                </div>
                            </el-form-item>
                        </div>
                    </el-form>
                </el-tab-pane>
                <el-tab-pane label="从会员添加" name="addFromLib">
                    <div class="fx-g1 fx-col fx-c_stretch">
                        <el-form ref="form" :model="form3" label-width="80px" class="edit_form">
                            <el-form-item label="关键词">
                                <el-input v-model="form3.keywords" suffix-icon="el-icon-search" style="width: 300px;margin-right: 20px"></el-input>
                            </el-form-item>
                        </el-form>

                        <el-table
                            ref="userTable"
                            :data="tableData"
                            stripe
                            class="fx-g1"
                            style="width: 100%"
                            @selection-change="handleUserChoose"
                        >
                            <el-table-column
                                type="selection"
                                width="55">
                            </el-table-column>
                            <el-table-column
                                min-width="120"
                                prop="name"
                                label="用户名称" >
                            </el-table-column>
                            <el-table-column
                                min-width="120"
                                prop="phone"
                                label="手机号" >
                            </el-table-column>
                            <el-table-column
                                prop="sn"
                                min-width="120"
                                label="系统账号" >
                            </el-table-column>
                        </el-table>
                        <div class=" fx fx-m_end fx-c_center" style="height: 50px">
                            <el-pagination
                                :background="true"
                                prev-text="上一页"
                                next-text="下一页"
                                layout="prev, pager, next"
                                :current-page="pager.currentPage"
                                :page-size="pager.pageSize"
                                :total="pager.dataTotal"
                                @current-change="pageChange"
                            >
                            </el-pagination>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="导入学生" name="addFromExcel">
                    <div class="fx-g1 fx-col fx-c_stretch fx-m_start">
                        <span style="width: 80%; margin: 30px 0;font-size: 16px" class="text_normal">导入学生数据：请严格按照模板样式上传，否则会导致数据导入失败！</span>
                        <div class="fx fx-center">
                            <div class="excel_opt fx-col fx-center" @click="downloadModal">
                                <i class="iconfont icon-yunshangchuan"></i>
                                <span>下载模板</span>
                            </div>
                            <i class="el-icon-arrow-right text_primary"></i>
                            <div class="excel_opt fx-col fx-center" @click="$refs.file.click()">
                                <i class="iconfont icon-yunxiazai"></i>
                                <span>上传Excel</span>
                                <input type="file" ref="file" @change="subExcel($event)" accept="application/vnd.ms-excel"  class="hide">
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>


        </div>
        <span  class="fx fx-center">
            <el-button v-if="activeTab=='addOne'" type="primary" @click="addOne()">保 存</el-button>
            <el-button v-if="activeTab=='addByBatch'" type="primary" @click="addBatch()">保 存</el-button>
            <el-button v-if="activeTab=='addFromLib'" type="primary" @click="addFromLib()">保 存</el-button>
            <el-button @click="close()">关 闭</el-button>
        </span>
    </el-drawer>
</template>

<style scoped>
    .excel_opt {
        width: 130px;
        height: 130px;
        border-radius: 10px;
        border: 1px solid var(--primary);
    }
    .excel_opt .iconfont{
        color: var(--primary);
        font-size: 50px;
    }
    i.el-icon-arrow-right {
        font-size: 50px;
        font-weight: bold;
        margin: 0 20px;
    }
</style>


<script>


    export default {
        props: [
            "classid",
            "hastype"
        ],
        data() {
            return {
                needRefreshParent: false,

                show: false,
                activeTab: "addOne",
                hasType: this.hastype,
                type:'1',//新生老生
                form: {},

                form2: {},

                form3: {},
                tableData: [],
                pager: {
                    pageSize: 12,
                    dataTotal: 0,
                    currentPage: 1
                },
                choosedUser: [],
            }

        },
        watch: {
            "form3": {
                handler: function (newValue) {
                    this.pager.currentPage = 1;
                    this.loadUsers();
                },
                deep: true

            }
        },


        methods: {
            close() {
                if (this.needRefreshParent) {
                    this.$emit("submit");
                } else {
                    this.$emit("close");
                }
            },
            addOne() {
                this.$ajaxPost("/user/save", {
                    user: {...this.form, isStudent: true, fromChannel: 1, classId: this.classid}
                }, (data) => {
                    this.$emit("submit", data.result);
                })
                return false;
            },
            addBatch() {
                if(this.hastype && this.type == 2){//是老生走sn添加
                    this.$ajaxPost("/user/addStudentsByBatchSns", {
                        ...this.form2,
                        classId: this.classid
                    }, data => {
                        this.$emit("submit");
                        this.$alert(data.result, '提示', {
                            cancelButtonText: '取消',
                            callback: action => {
                            }
                        });
                    })
                    return;
                }
                this.$ajaxPost("/user/addStudentsByBatch", {
                    ...this.form2,
                    classId: this.classid
                }, data => {
                    this.$emit("submit");
                })
            },
            handleUserChoose(val) {
                this.choosedUser = val;
            },
            loadUsers() {
                if (this.classid) { //如果只是添加到班级，那就查不在这个班的学生
                    this.$ajaxPost("/user/list", {
                        form: {...this.form3, classId: this.classid ? (0 -this.classid) : null}, //classid为负数，表示排除这个班的学生
                        pager: {...this.pager, dataTotal: 0}
                    }, (data) => {
                        //分页不能带offset，否则会影响后台计算最新offset
                        let {offset, ...pager} = data.pager;
                        this.pager = pager;
                        this.tableData = data.result;
                    })
                }  else { //否则就查所有的非学生数据
                    this.$ajaxPost("/user/listNotStudentUsers", {
                        form: this.form3,
                        pager: {...this.pager, dataTotal: 0}
                    }, (data) => {
                        //分页不能带offset，否则会影响后台计算最新offset
                        let {offset, ...pager} = data.pager;
                        this.pager = pager;
                        this.tableData = data.result;
                    })
                }

            },
            addFromLib() {
                if (this.choosedUser.length == 0) {
                    this.$showError("请选取后再操作");
                    return;
                }
                let users = this.choosedUser.map(item => {
                    return {...item, isStudent: true, classId: this.classid}
                })

                this.$ajaxPost("/user/addPositionsFromUsers", {
                    users: users
                }, (data) => {
                    this.$showSuccess("添加成功");
                    this.$emit("submit");
                    this.needRefreshParent = true;
                })
                return false;
            },
            pageChange(page) {
                this.pager.currentPage = page;
                this.loadUsers();
            },

            downloadModal() {
                window.open("/user/downloadStudentExcelModal?token="+localStorage.getItem("token"));
            },
            subExcel(e) {
                if (e.target.value) {
                    this.uploading = true;
                    let file = e.target.files[0];
                    this.$upload("/user/addFromExcel", {file: file, classId: this.classid}, data => {
                        this.$showSuccess("上传成功");
                        this.uploading = false;
                        this.needRefreshParent = true;
                    }, data => {
                        this.uploading = false;
                        this.$showError(data.msg);
                    })
                    e.target.value = null;
                }
            },

        },
        mounted() {
            this.show = true;
        },
        created() {
            this.loadUsers();
        }


    }
</script>
